module.exports = __webpack_public_path__ + "media/images/icons/country_flags/lc-a5f7f2065e6c2a79aea5323643ce279f.svg";